import { render, staticRenderFns } from "./Estrategicos.vue?vue&type=template&id=3c4b72e6"
import script from "./Estrategicos.vue?vue&type=script&lang=js"
export * from "./Estrategicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports